/** `2.5` is what turns a $100K ceiling into $25K ticks instead of $30K ones. */
const NICE_MULTIPLES: readonly number[] = [1, 2, 2.5, 5];

const MIN_TICK_STEP_DOLLARS = 1;

/**
 * Rounds a rough tick interval up to the next readable one, so an axis is labelled in figures a
 * reader recognizes rather than in exact fractions of the tallest value.
 */
export const niceStep = (rough: number): number => {
  // A $0 projection is reachable: a $0 start whose first contribution has not posted yet.
  if (rough <= 0) return MIN_TICK_STEP_DOLLARS;

  const magnitude = 10 ** Math.floor(Math.log10(rough));
  const multiple = NICE_MULTIPLES.find(candidate => rough <= candidate * magnitude);

  // Nothing below the next power of ten fits, so the ceiling rounds up to it.
  return Math.max(MIN_TICK_STEP_DOLLARS, (multiple ?? 10) * magnitude);
};
